<template>
  <div class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h2 class="modal-title">{{ t('footer.serviceAgreement') }}</h2>
        <button
          @click="$emit('close')"
          class="modal-close"
          aria-label="Close"
        >
          <svg style="width: 1.5rem; height: 1.5rem" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <div class="markdown-content" v-html="renderedMarkdown" />
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button @click="$emit('close')" class="btn btn-primary w-full">
          {{ t('common.close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { marked } from 'marked';
import { useI18n } from 'vue-i18n';

// Import markdown files as raw text
import serviceAgreementEn from '@/i18n/legal/serviceAgreement.en.md?raw';
import serviceAgreementFi from '@/i18n/legal/serviceAgreement.fi.md?raw';
import serviceAgreementSv from '@/i18n/legal/serviceAgreement.sv.md?raw';

// Define emits
defineEmits<{
  close: []
}>();

const { locale, t } = useI18n();

// Configure marked options
marked.setOptions({
  breaks: true,
  gfm: true,
});

// Get the correct markdown content based on current locale
const markdownContent = computed(() => {
  switch (locale.value) {
    case 'en':
      return serviceAgreementEn;
    case 'fi':
      return serviceAgreementFi;
    case 'sv':
      return serviceAgreementSv;
    default:
      return serviceAgreementEn;
  }
});

// Parse markdown to HTML
const renderedMarkdown = computed(() => {
  return marked.parse(markdownContent.value);
});
</script>
